<template>
	<div>
		<!-- 面包屑导航 -->
		<div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item class="mybread" :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item class="mybread">发展对象权限</el-breadcrumb-item>
				<el-breadcrumb-item class="mybread">微行动</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- 第一行搜索框和新增按钮 -->
		<el-row type="flex" align="middle" class="myRow">
			<el-col :span="5">活动类型</el-col>
			<el-col :span="10">
				<el-select v-model="queryInfo.type" placeholder="请选择" filterable @change="mygetActivityList()">
					<el-option v-for="item in wxdtype" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="5" :offset="1">活动搜索</el-col>
			<el-col :span="15">
				<el-input placeholder="请输入活动名称" v-model="queryInfo.name" clearable>
					<el-button slot="append" icon="el-icon-search" @click="mygetActivityList()"></el-button>
				</el-input>
			</el-col>
			<el-col :offset="1">
				<el-button type="primary"
					@click="addActiStep1Visible = true; addActiStep2Visible = true">新增活动</el-button>
			</el-col>
		</el-row>
		<!-- 新增活动对话框-->
		<el-dialog title="新增活动" :visible.sync="addActiStep1Visible" width="30%" >
			<el-form :model="addActiForm" :rules="addActiFormRules" ref="addActiFormRef" label-width="100px"
				v-if="addActiStep2Visible">
				<div style="margin-bottom: 30px;font-size: 18px;font-weight: 600;">Step1:填写活动基本信息</div>
				<el-form-item label="活动类型" prop="type">
					<el-select v-model="addActiForm.type" placeholder="请选择" filterable>
						<el-option v-for="item in wxdtype" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="活动名称" prop="name">
					<el-input v-model="addActiForm.name"></el-input>
				</el-form-item>
				<el-form-item label="活动时间" prop="date">
					<el-date-picker type="date" placeholder="选择日期" v-model="addActiForm.date" style="width: 100%;"
						value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="活动分值" prop="score">
					<el-input v-model="addActiForm.score"></el-input>
				</el-form-item>

			</el-form>

			<div label-width="100px" v-else>
				<div style="margin-bottom: 30px;font-size: 15px;font-weight: 700;">Step2:上传活动证明</div>
				<div>
					<el-upload class="upload-demo" accept=".jpg,.png,.jpeg" drag :action="this.action" multiple :headers="this.token" :file-list="uploadList" :on-change="loadJsonFromFile">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">只能上传JPG,PNG,JPEG等文件，且不超过2M</div>
					</el-upload>
				</div>
			</div>
			<span slot="footer" class="dialog-footer" v-if="addActiStep2Visible">
				<el-button @click="addActiStep1Visible = false">取 消</el-button>
				<el-button type="primary" @click="myaddActivityStep1()">确 定</el-button>
			</span>
			<span slot="footer" class="dialog-footer" v-else>
				<el-button @click="addActiStep1Visible = false">取 消</el-button>
				<el-button type="primary" @click="myaddActivityStep2()">完 成</el-button>
			</span>
		</el-dialog>
		<!-- 得分列表-->
		<el-table border :show-summary="true" :header-row-style="{ height: '60px' }" :row-style="{ height: '30px' }"
			:data="wxdList" :highlight-current-row='true' :header-cell-style="{
				background: '#fff1f0', height: '60px', color: '#000000'
			}">
			<el-table-column type="index" label="序号" width="50px"> </el-table-column>
			<el-table-column prop="type" label="活动类型" width="250px">
			</el-table-column>
			<el-table-column prop="name" label="活动名称" width="300px">
			</el-table-column>

			<el-table-column prop="date" label="活动日期" width="200px">
			</el-table-column>
			<el-table-column prop="score" label="活动分值" width="100x">
			</el-table-column>
			<el-table-column prop="approve" label="活动状态" width="100x">
			</el-table-column>
			<el-table-column label="操作" width="250px">
				<template slot-scope="scope">
					<el-button  @click="handleApprove(scope.row)" size="small" icon="el-icon-search">
						查看活动</el-button>
					<el-button type="danger" @click="mydeleteActivity(scope.row.id)" size="small" icon="el-icon-delete">
						删除活动</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="approveReason" label="审核（退回）理由" width="150x">
            </el-table-column>
		</el-table>
		<!--分页区域-->
		<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
			:current-page="queryInfo.pageNumber" :page-sizes="[1, 5, 30, 50]" :page-size="queryInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total=count>
		</el-pagination>
		 <!-- 查看活动对话框-->
		 <el-dialog title="查看活动" :visible.sync="showDialogVisible" width="35%">
            <el-form :model="approveForm">
                <el-form-item label="活动类型：" prop="type">
                    <span style="margin-left: 5px" >{{ approveForm.type }}</span>
                </el-form-item>
                <el-form-item label="活动名称:" prop="name">
                    <span style="margin-left: 5px" >{{ approveForm.name }}</span>
                </el-form-item>
                <el-form-item label="活动时间:" prop="date">
                    <span style="margin-left: 5px" >{{ approveForm.date }}</span>
                </el-form-item>
                <el-form-item label="活动分值:" prop="score">
                    <span style="margin-left: 5px" >{{ approveForm.score }}</span>
                </el-form-item>
                <el-form-item label="活动附件:">
                    <div v-for="item in approveForm.currentFiles"  :key="item.value" class="img_container">
                        <viewer>
                        <img :src=getFileUrl(approveForm,item.fileName)>
                        </viewer>
                    </div>
                </el-form-item>
              
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDialogVisible = false">关闭</el-button>
             
            </span>
        </el-dialog>
	</div>
</template>

<script>
import { addActivity, deleteActivity, listCurrentActivity,listFiles } from "@/utils/api.js"
import { getToken } from '../../utils/auth';
import axios from "axios";
export default {
	data() {
		return {
          //控制上传申请书对话框的显示与隐藏
			addActiStep1Visible: false,
			addActiStep2Visible: false,
			queryInfo: {
				name: '',
				dateStart: '',
				dateEnd: '',
				createTimeStart: '',
				createTimeEnd: '',
				type: '微行动',
				pageSize: 30,
				pageNumber:1,
				approve: -1,

			},
			count: '',
			  //查看活动对话框的显示与隐藏
			  showDialogVisible: false,
			  approveForm: {
                userId:'',
                type: '',
                name: '',
                date: '',
                score: '',
                id: '',
                fullName:'',
                banji:'',
                fullName:'',
                currentFiles: '',
                approve: -1,
                
            },

			//微行动活动类型下拉菜单选项
			wxdtype: [
				{
					value: '',
					label: '请选择'
				},
				{
					value: "微行动_课堂纪律",
					label: "微行动_课堂纪律",
				}, {
					value: "微行动_阳光长跑",
					label: "微行动_阳光长跑"
				},{
					value: "微行动_6S示范寝室",
					label: "微行动_6S示范寝室"
				}
			],
			 //文件上传列表
			 uploadList:[],
			addActiForm: {
				type: '',
				name: '',
				date: '',
				score: ''
			},
			action: 'http://36.134.183.225:9898/activity/uploadFile',
			wxdList: [],
			addActiFormRules: {
				type: [{
					required: true, message: "请选择活动类型"
				}],
				name: [{
					required: true, message: "请填写活动名称"
				}],
				score: [{
					required: true, message: "请填写活动分数"
				}],
				date: [{
					required: true, message: "请填写活动日期"
				}],
			}

		}
	},
	created() {
		this.myToken();
		this.mygetActivityList();

	},
	methods: {
		loadJsonFromFile(file, fileList) {
			this.uploadList = fileList;
		},
		//获取到token
		myToken() {
			const retoken = getToken();
			this.token = { Authorization: retoken };
		},
		myaddActivityStep1() {		
				addActivity(this.addActiForm).then(result => {
				if (result.code === '0000') {
					this.$message.success(result.message);
					this.action = 'http://36.134.183.225:9898/activity/uploadFile?id=' + result.data;
					this.addActiStep2Visible = false;
					Object.assign(this.$data.addActiForm, this.$options.data().addActiForm);
				} else {
					console.log(result)
				}
			})
					
		},
		myaddActivityStep2() {
			if(this.uploadList.length==0){
			this.$message.error('未上传附件，活动创建失败');
			this.mydeleteActivity(this.codeNumber);
			this.addActiStep1Visible = false;
			this.uploadList=[];
		}else{
			this.addActiStep1Visible = false;
			this.mygetActivityList();
			this.uploadList=[];
		}
			
		},
		//查看当前用户活动
		mygetActivityList() {
			listCurrentActivity(this.queryInfo).then(result => {
				if (result.code === '0000') {
					var tempArray = result.data[0];
					var j = 0;
					var newWxdArray = [];
					//查找符合条件值并存入新数组
					for (let i in tempArray) {
						
						if (tempArray[i].approve == 0) {
							tempArray[i].approve = '未审核';
						} else if (tempArray[i].approve == 1) {
							tempArray[i].approve = '已通过';
						} else if (tempArray[i].approve == 2) {
							tempArray[i].approve = '未通过';
						}
					}
					this.wxdList = result.data[0];
					this.count = result.data[1][0];
				} else {
					console.log(result)
				}
			})
		},
		async handleApprove(row) {
            this.approveForm = row;
            this.approveForm.currentFiles = await this.mylistCurrentFiles()
            this.showDialogVisible = true;

        },
		getFileUrl(approveForm,file){
            return axios.defaults.baseURL+'/activity/downloadFile?userId='+approveForm.userId+'&id='+approveForm.id+'&fileName='+file+'&token='+getToken()
        },
		async mylistCurrentFiles() {
            let files = []
            await listFiles({ id: this.approveForm.id, userId: this.approveForm.userId }).then(result => {

                if (result.code === '0000') {
                    for (let i in result.data) {
                        files.push(result.data[i])
                    }

                } else {
                    console.log(result)

                }
            })
            return files
        },
		mydeleteActivity(id) {
			const parma = { 'id': id };
			deleteActivity(parma).then(result => {
				if (result.code === '0000') {
					this.$message.success('删除成功');
					this.mygetActivityList();
				} else {
					console.log(result)
				}
			})
		},//监听PageSize的长度
		handleSizeChange(newSize) {
			this.queryInfo.pageSize = newSize;
			this.mygetActivityList();

		},
		//监听页码值改变的事件
		handleCurrentChange(newPage) {
			this.queryInfo.pageNumber = newPage;
			this.mygetActivityList();
			this.queryInfo.pageNumber = 1;
	
		},

	}
}
</script>

<style>
.title {
	font-size: 20px;
}

.basicInfo {
	height: 300px;
	width: 500px;
	background-color: bisque;
}

.el-button--primary {
	background-color: darkred;
	color: #fff;
	border-color: darkred;
	width: 130px;
	font-size: 18px;
}

.el-button--primary:focus,
.el-button--primary:hover {
	background: yellow;
	border-color: #66b1ff;
	color: #FFF;
}

.el-upload {
	width: 100%;
}

.el-upload .el-upload-dragger {
	width: 100%;
}

.el-breadcrumb .el-breadcrumb__inner {
	color: grey;
	font-size: 18px;
}

.myRow {
	margin-top: 50px;
	margin-bottom: 30px;
	margin-left: 20px;
}

.el-table {
	overflow: visible !important;
}
</style>